import Styles from './styles.module.css';
import React, { useState } from 'react';
import { RxCross2 } from "react-icons/rx";
import salonType1 from './../../../image/salonType/1.png';
import salonType2 from './../../../image/salonType/2.png';
import salonType3 from './../../../image/salonType/3.png';
import salonType4 from './../../../image/salonType/4.png';
import salonType5 from './../../../image/salonType/5.png';
import salonType6 from './../../../image/salonType/6.png';
import salonType7 from './../../../image/salonType/7.png';
import salonType8 from './../../../image/salonType/8.png';
import salonTypeDesc1 from './../../../image/salonType/desc/1.png';
import salonTypeDesc2 from './../../../image/salonType/desc/2.png';
import salonTypeDesc3 from './../../../image/salonType/desc/3.png';
import salonTypeDesc4 from './../../../image/salonType/desc/4.png';
import salonTypeDesc5 from './../../../image/salonType/desc/5.png';
import salonTypeDesc6 from './../../../image/salonType/desc/6.png';
import { PREFECTURES, SALARY_OPTIONS } from 'src/type';
import { CiCircleQuestion } from "react-icons/ci";
import { educationTags, salaryTags, styleTags, treatmentTags, workTags } from 'src/type';

type SchoolTypeProps = {
  setSearchToggle: React.Dispatch<React.SetStateAction<boolean>>;

  business: string;
  setBusiness: React.Dispatch<React.SetStateAction<string>>;
  targetSelect: string;
  setTargetSelect: React.Dispatch<React.SetStateAction<string>>;
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  searchPref: string;
  setSearchPref: React.Dispatch<React.SetStateAction<string>>;
  searchSalary: string;
  setSearchSalary: React.Dispatch<React.SetStateAction<string>>;
  searchType: string;
  setSearchType: React.Dispatch<React.SetStateAction<string>>;
  searchHashTags: string[];
  setSearchHashTags: React.Dispatch<React.SetStateAction<string[]>>;
  // 指定している検索条件の数と、すべての条件をまとめて外す処理
  activeConditionCount: number;
  onReset: () => void;
};

const SchoolType: React.FC<SchoolTypeProps> = ({ business, setBusiness, setSearchToggle, targetSelect, setTargetSelect, searchText, setSearchText, searchPref, setSearchPref, searchSalary, setSearchSalary, searchType, setSearchType, searchHashTags, setSearchHashTags, activeConditionCount, onReset }) => {

  const [ question, setQuestion ] = useState<string>("");

  // 学生アプリ(見つける > フィルター)と同じ上限: 施術・スタイルは併せて1個まで、
  // 給与・待遇・福利厚生〜働き方〜教育体制は合計5個まで(グループは独立)。
  const hashToggle = (tag: string) => {
    if (searchHashTags.includes(tag)) {
      setSearchHashTags(searchHashTags.filter((t: string) => t !== tag));
      return;
    }

    const isTreatmentOrStyle = treatmentTags.includes(tag) || styleTags.includes(tag);
    const treatmentOrStyleCount = searchHashTags.filter(
      (t) => treatmentTags.includes(t) || styleTags.includes(t)
    ).length;
    if (isTreatmentOrStyle && treatmentOrStyleCount >= 1) return;

    const isBenefitGroup = salaryTags.includes(tag) || workTags.includes(tag) || educationTags.includes(tag);
    const benefitGroupCount = searchHashTags.filter(
      (t) => salaryTags.includes(t) || workTags.includes(t) || educationTags.includes(t)
    ).length;
    if (isBenefitGroup && benefitGroupCount >= 5) return;

    setSearchHashTags([...searchHashTags, tag]);
  };

  const closeAndClear = () => {
    setSearchToggle(false);
  };

  return (
    <>
    <div className={Styles.modal}>
      <div className={Styles.background_black} onClick={() => closeAndClear()}></div>
      <div className={Styles.contents} style={question ? {height: "500px"} : {}}>
        
        <div className={Styles.modal_title}>
          <h4>求人検索</h4>
          <button
            type="button"
            className={Styles.modal_reset}
            onClick={onReset}
            disabled={activeConditionCount === 0}
          >
            すべてリセット{activeConditionCount > 0 ? `（${activeConditionCount}）` : ''}
          </button>
          <RxCross2 className={Styles.modal_cross} onClick={() => closeAndClear()} />
        </div>

        <div className={Styles.modal_section}>
          <h5>卒業時年齢</h5>
          <div className={Styles.modal_tags}>
            <select value={targetSelect} onChange={(e) => setTargetSelect(e.target.value)} defaultValue="">
              <option value="">卒業時年齢</option>
              <option value="専門(20歳卒)">専門(20歳卒)</option>
              <option value="高専(18歳卒)">高専(18歳卒)</option>
              <option value="高専(17歳卒)">高専(17歳卒)</option>
            </select>
          </div>
        </div>

        <div className={Styles.modal_section}>
          <h5>職種</h5>
          <div className={Styles.modal_tags}>
            <select value={business} onChange={(e) => setBusiness(e.target.value)} defaultValue="">
              <option value="">職種</option>
              <option value="理容">理容</option>
              <option value="美容">美容</option>
              <option value="メイク">メイク</option>
              <option value="ネイル">ネイル</option>
              <option value="アイ">アイ</option>
              <option value="ブライダル">ブライダル</option>
              <option value="エステ">エステ</option>
              <option value="その他">その他</option>
            </select>
          </div>
        </div>

        <div className={Styles.modal_section}>
          <h5>企業名検索</h5>
          <div className={Styles.modal_tags}>
            <input placeholder='株式会社memorii' value={searchText} onChange={(e) => setSearchText(e.target.value)} />
          </div>
        </div>
        
        <div className={Styles.modal_section}>
          <h5>都道府県</h5>
          <div className={Styles.modal_tags}>
            <select value={searchPref} onChange={(e) => setSearchPref(e.target.value)} defaultValue="">
              <option value="">都道府県</option>
              {PREFECTURES.map((prefecture) => (
                <option key={prefecture} value={prefecture}>
                  {prefecture}
                </option>
              ))}
            </select>
          </div>
        </div>
        
        <div className={Styles.modal_section}>
          <h5>給与</h5>
          <div className={Styles.modal_tags}>
            <select value={searchSalary} onChange={(e) => setSearchSalary(e.target.value)} defaultValue="">
              <option value="">給与</option>
              {SALARY_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}万円以上
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className={Styles.modal_section}>
          <div className={Styles.modal_section_title}>
            <h5>8タイプ診断</h5>
            <h6 onClick={() => setSearchType("")}>クリア</h6>
          </div>
          <div className={Styles.modal_tags}>
            <div>
              <div className={Styles.type_box} style={searchType === "有名サロン" ? {} : {opacity : ".3"}} onClick={() => setSearchType("有名サロン")}>
                <CiCircleQuestion className={Styles.type_questions} onClick={() => setQuestion("有名サロン")} />
                <img src={salonType1} />
              </div>
              <div className={Styles.type_box} style={searchType === "トレンドサロン" ? {} : {opacity : ".3"}} onClick={() => setSearchType("トレンドサロン")}>
                <CiCircleQuestion className={Styles.type_questions} onClick={() => setQuestion("トレンドサロン")} />
                <img src={salonType2} />
              </div>
              <div className={Styles.type_box} style={searchType === "おしゃれサロン" ? {} : {opacity : ".3"}} onClick={() => setSearchType("おしゃれサロン")}>
                <CiCircleQuestion className={Styles.type_questions} onClick={() => setQuestion("おしゃれサロン")} />
                <img src={salonType3} />
              </div>
              <div className={Styles.type_box} style={searchType === "ビューティーサロン" ? {} : {opacity : ".3"}} onClick={() => setSearchType("ビューティーサロン")}>
                <CiCircleQuestion className={Styles.type_questions} onClick={() => setQuestion("ビューティーサロン")} />
                <img src={salonType4} />
              </div>
            </div>
            <div>
              <div className={Styles.type_box} style={searchType === "オールラウンドサロン" ? {} : {opacity : ".3"}} onClick={() => setSearchType("オールラウンドサロン")}>
                <CiCircleQuestion className={Styles.type_questions} onClick={() => setQuestion("オールラウンドサロン")} />
                <img src={salonType5} />
              </div>
              <div className={Styles.type_box} style={searchType === "愛されサロン" ? {} : {opacity : ".3"}} onClick={() => setSearchType("愛されサロン")}>
                <CiCircleQuestion className={Styles.type_questions} onClick={() => setQuestion("愛されサロン")} />
                <img src={salonType6} />
              </div>
              <div className={Styles.type_box} style={searchType === "密着サロン" ? {} : {opacity : ".3"}} onClick={() => setSearchType("密着サロン")}>
                <CiCircleQuestion className={Styles.type_questions} onClick={() => setQuestion("密着サロン")} />
                <img src={salonType7} />
              </div>
              <div className={Styles.type_box} style={searchType === "こだわりサロン" ? {} : {opacity : ".3"}} onClick={() => setSearchType("こだわりサロン")}>
                <CiCircleQuestion className={Styles.type_questions} onClick={() => setQuestion("こだわりサロン")} />
                <img src={salonType8} />
              </div>
            </div>
          </div>
        </div>
        
        <div className={Styles.modal_section}>
          <h5>施術の特徴</h5>
          <div className={Styles.modal_tags}>
            {treatmentTags.map((tag) => (
              <button key={tag} onClick={() => hashToggle(tag)} style={ searchHashTags.includes(tag) ? { backgroundColor: 'var(--mw-brand)', color: 'white' } :  {} }>
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className={Styles.modal_section}>
          <h5>スタイルの特徴</h5>
          <div className={Styles.modal_tags}>
            {styleTags.map((tag) => (
              <button key={tag} onClick={() => hashToggle(tag)} style={ searchHashTags.includes(tag) ? { backgroundColor: 'var(--mw-brand)', color: 'white' } :  {} }>
                {tag}
              </button>
            ))}
          </div>
        </div>
        <p>施術・スタイルのハッシュタグは、併せて1個までの選択となります。</p>

        <div className={Styles.modal_section}>
          <h5>給与・待遇・福利厚生の特徴</h5>
          <div className={Styles.modal_tags}>
            {salaryTags.map((tag) => (
              <button key={tag} onClick={() => hashToggle(tag)} style={ searchHashTags.includes(tag) ? { backgroundColor: 'var(--mw-brand)', color: 'white' } :  {} }>
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className={Styles.modal_section}>
          <h5>働き方の特徴</h5>
          <div className={Styles.modal_tags}>
            {workTags.map((tag) => (
              <button key={tag} onClick={() => hashToggle(tag)} style={ searchHashTags.includes(tag) ? { backgroundColor: 'var(--mw-brand)', color: 'white' } :  {} }>
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className={Styles.modal_section}>
          <h5>教育体制の特徴</h5>
          <div className={Styles.modal_tags}>
            {educationTags.map((tag) => (
              <button key={tag} onClick={() => hashToggle(tag)} style={ searchHashTags.includes(tag) ? { backgroundColor: 'var(--mw-brand)', color: 'white' } :  {} }>
                {tag}
              </button>
            ))}
          </div>
        </div>
        <p>給与・待遇・福利厚生～教育体制の特徴のハッシュタグは、合計5個までの選択となります。</p>

        <div style={{height: "30px"}}></div>
      
      </div>
    </div>

    {question && (
    <div className={Styles.modal}>
      <div className={Styles.background_black} onClick={() => setQuestion("")}></div>
      <div className={Styles.contents}>
        
        <div className={Styles.modal_scroll} style={question ? {height: "390px"} : {}}>
          
          <div className={Styles.modal_title}>
            <h4>求人検索</h4>
            <RxCross2 className={Styles.modal_cross} onClick={() => setQuestion("")} />
          </div>

          <div className={Styles.modal_section}>

            <div className={Styles.modal_section_contents}>
              <img src={question === "有名サロン" ? salonType1 : question === "トレンドサロン" ? salonType2 : question === "おしゃれサロン" ? salonType3 : question === "ビューティーサロン" ? salonType4 :
                question === "オールラウンドサロン" ? salonType5 : question === "愛されサロン" ? salonType6 : question === "密着サロン" ? salonType7 : question === "こだわりサロン" ? salonType8 : ""} />
              <div className={Styles.type_desc}>
                <p>顧客層（都会型 or 地域型）</p>
                <div>
                  <img src={question === "有名サロン" || question === "おしゃれサロン" || question === "ビューティーサロン" || question === "トレンドサロン" ? salonTypeDesc1 : salonTypeDesc2} />
                  <div>
                    <h4>{question === "有名サロン" || question === "おしゃれサロン" || question === "ビューティーサロン" || question === "トレンドサロン" ? "都会型" : "地域型"}</h4>
                    <p>{question === "有名サロン" || question === "おしゃれサロン" || question === "ビューティーサロン" || question === "トレンドサロン" ? '地域住民の方以外のお客さまが多いサロン' : "地域住民の方がお客さまが多いサロン"}</p>
                  </div>
                </div>
                <p>強み（集客 or 技術）</p>
                <div>
                  <img src={question === "有名サロン" || question === "トレンドサロン" || question === "オールラウンドサロン" || question === "愛されサロン" ? salonTypeDesc3 : salonTypeDesc4} />
                  <div>
                    <h4>{question === "有名サロン" || question === "トレンドサロン" || question === "オールラウンドサロン" || question === "愛されサロン" ? "集客" : "技術"}</h4>
                    <p>{question === "有名サロン" || question === "トレンドサロン" || question === "オールラウンドサロン" || question === "愛されサロン" ? '技術に比べて、集客に力を入れているサロン' : '集客に比べて、技術に力を入れているサロン'}</p>
                  </div>
                </div>
                <p>施術幅（オールマイティー or 専門）</p>
                <div>
                  <img src={question === "有名サロン" || question === "おしゃれサロン" || question === "オールラウンドサロン" || question === "密着サロン" ? salonTypeDesc5 : salonTypeDesc6} />
                  <div>
                    <h4>{question === "有名サロン" || question === "おしゃれサロン" || question === "オールラウンドサロン" || question === "密着サロン" ? "オールマイティー" : "専門"}</h4>
                    <p>{question === "有名サロン" || question === "おしゃれサロン" || question === "オールラウンドサロン" || question === "密着サロン" ? '提供するサービスが幅広いサロン' : '特化したサービス提供を行っているサロン'}</p>
                  </div>
                </div>
              </div>
            </div>
          </div> 
        </div>

      </div>
    </div> )}
    </>
  );
}

export default SchoolType;